/* Aarna - instant navigation prefetch. 2026-08-07

   Warms the NEXT page while the visitor is still deciding to click it: on
   desktop after a short hover, on touch at touchstart (which lands ~90-300ms
   before the click event). By the time the click fires the HTML is usually
   already in the HTTP cache, so navigation feels instant.

   This is first-party and dependency-free on purpose - no instant.page, no
   third-party CDN. A speed fix that adds a blocking request to someone else's
   domain is not a speed fix.

   IT DOES NOT SPEED UP THE FIRST PAGE VIEW. Ad traffic lands cold, so this does
   nothing for the LCP a Lighthouse run on the PDP reports. It pays off on the
   second hop - PDP to cart, collection to PDP - which is where the store
   actually loses people.

   SAFETY RULES (a prefetch is a real GET the server will answer):
   - Same-origin only, and never /cart, /checkout, /account, /orders or any app
     proxy path. Prefetching an add-to-cart or logout URL would mutate the
     visitor's session without them clicking anything.
   - Capped at MAX urls per page view so a long collection page cannot turn a
     mouse sweep into dozens of requests.
   - Skipped entirely on Save-Data and 2G, where speculative bytes cost the
     visitor more than the saved wait is worth.
   - Opt out per link with data-no-prefetch.
*/
(function(){
  'use strict';
  if(window.__PK_INSTANT_NAV__)return;
  window.__PK_INSTANT_NAV__=true;

  var conn=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
  if(conn){
    if(conn.saveData)return;
    if(String(conn.effectiveType||'').indexOf('2g')!==-1)return;
  }

  var probe=document.createElement('link');
  if(!(probe.relList&&probe.relList.supports&&probe.relList.supports('prefetch')))return;

  var MAX=12;
  var HOVER_DELAY=65;
  var seen=Object.create(null);
  var count=0;
  var timer=null;

  /* Paths that must never be prefetched: they either change server-side state
     or are per-session and pointless to cache. */
  var BLOCKED=/^\/(cart|checkout|account|orders|apps|services|tools|wpm)(\/|$)/i;
  var BLOCKED_QUERY=/(logout|add-to-cart|discount|customer_posted)/i;

  function eligible(a){
    if(!a||!a.href)return false;
    if(a.origin!==window.location.origin)return false;
    if(a.protocol!=='http:'&&a.protocol!=='https:')return false;
    if(a.hasAttribute('download'))return false;
    if(a.target&&a.target!=='_self')return false;
    if(a.hasAttribute('data-no-prefetch'))return false;
    var rel=a.getAttribute('rel')||'';
    if(/nofollow|external/i.test(rel))return false;
    if(BLOCKED.test(a.pathname))return false;
    if(a.search&&BLOCKED_QUERY.test(a.search))return false;
    var url=a.href.split('#')[0];
    if(url===window.location.href.split('#')[0])return false;
    return true;
  }

  function prefetch(a){
    if(count>=MAX)return;
    var url=a.href.split('#')[0];
    if(seen[url])return;
    seen[url]=true;
    count++;
    var link=document.createElement('link');
    link.rel='prefetch';
    link.as='document';
    link.href=url;
    document.head.appendChild(link);
  }

  function anchorFrom(event){
    var node=event.target;
    if(!node||!node.closest)return null;
    return node.closest('a[href]');
  }

  function onEnter(event){
    var a=anchorFrom(event);
    if(!eligible(a))return;
    window.clearTimeout(timer);
    timer=window.setTimeout(function(){prefetch(a);},HOVER_DELAY);
  }

  function onLeave(){
    window.clearTimeout(timer);
  }

  function onTouch(event){
    var a=anchorFrom(event);
    if(eligible(a))prefetch(a);
  }

  document.addEventListener('mouseover',onEnter,{capture:true,passive:true});
  document.addEventListener('mouseout',onLeave,{capture:true,passive:true});
  document.addEventListener('touchstart',onTouch,{capture:true,passive:true});
})();
